import React from 'react';
import { Menu, RefreshCw } from 'lucide-react';
import type { Section } from '@/types';

interface HeaderProps {
    currentSection: Section;
    onMenuClick: () => void;
    onRefresh?: () => void;
    loading?: boolean;
    className?: string;
}

const sectionTitles: Record<Section, string> = {
    user: 'User Information',
    penalties: 'Penalties',
    parkings: 'Parkings',
    cars: 'Cars',
    'credit-cards': 'Credit Cards',
};

export const Header: React.FC<HeaderProps> = ({
                                                  currentSection,
                                                  onMenuClick,
                                                  onRefresh,
                                                  loading = false,
                                                  className = '',
                                              }) => {
    return (
        <header className={`bg-white shadow-sm border-b border-gray-200 ${className}`}>
            <div className="flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    {/* Mobile menu button */}
                    <button
                        type="button"
                        className="lg:hidden -ml-2 mr-3 p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
                        onClick={onMenuClick}
                    >
                        <Menu className="h-6 w-6" />
                    </button>

                    {/* Page title */}
                    <div>
                        <h1 className="text-2xl font-semibold text-gray-900">
                            {sectionTitles[currentSection]}
                        </h1>
                        <p className="text-sm text-gray-500 mt-1">
                            View and manage user data
                        </p>
                    </div>
                </div>

                {/* Actions */}
                <div className="flex items-center space-x-3">
                    {onRefresh && (
                        <button
                            onClick={onRefresh}
                            disabled={loading}
                            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            <RefreshCw
                                className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`}
                            />
                            Refresh
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
